import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { DialogActions } from "@material-ui/core";
import Swal from "sweetalert2";
import { onPreventEnterSubmitting, setObject } from "../../../../utils/utils";
import {
  CustomSelectField,
  CustomTextField,
} from "../../../../partials/content/Forms";
import { savePeriodStatus } from "../../../../services/finance/finance";
import { Formik } from "formik";
import store from "../../../../store/store";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
function OpenClosePeriodForm({ period, onConfirmSave, onCloseDialog }) {
  const taxFormSchema = yup.object().shape({
    ID: yup.number().default(0),
    statusID: yup.number().min(2, "Please select Fiscal Period status"),
    statusName: yup.string().required("Please select Fiscal Period status"),
  });
  const { socket } = useGlobalData();
  const [periodData, setPeriodData] = useState({
    ID: 0,
    fiscalyearID: 0,
    statusID: 0,
    statusName: "",
    year: 0,
    month: 0,
    monthName: "",
    openingDate: DateTime.now(),
    closingDate: DateTime.now(),
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });
  useEffect(() => {
    const { auth } = store.getState();

    if (period && period.ID > 0) {
      setObject(socket, "lock", period.ID, "OCPR", auth.user)
        .then((response) => {
          setPeriodData({
            ID: period.ID,
            fiscalYearID: period.fiscalYearID,
            statusID: period.statusID,
            statusName: period.statusName,
            year: period.year,
            month: period.month,
            monthName: period.monthName,
            openingDate: period.openingDate,
            closingDate: period.closingDate,
            CreatedAt: period.CreatedAt,
            UpdatedAt: period.UpdatedAt,
            createdBy: period.createdBy,
            updatedBy: period.updatedBy,
          });
        })
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (period && period.ID > 0) {
        setObject(socket, "release", period.ID, "OCPR", auth.user);
      }
    };
  }, [period]);
  return (
    <React.Fragment>
      <Formik
        initialValues={periodData}
        validationSchema={taxFormSchema}
        enableReinitialize={true}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Fiscal Period Status ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                savePeriodStatus(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        {({
          values,
          status,
          errors,
          touched,
          setFieldValue,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form
            noValidate={true}
            autoComplete="off"
            className="kt-form"
            onSubmit={handleSubmit}
            onKeyDown={onPreventEnterSubmitting}
          >
            <CustomTextField
              label="Fiscal Year"
              inputType="text"
              propertyName="year"
              onBlur={handleBlur}
              onChange={handleChange}
              values={values}
              touched={touched}
              errors={errors}
              endAdornment={{
                readOnly: true,
              }}
              disabled={true}
              size="small"
            />
            <CustomTextField
              label="Fiscal Period"
              inputType="text"
              propertyName="monthName"
              onBlur={handleBlur}
              onChange={handleChange}
              values={values}
              touched={touched}
              errors={errors}
              endAdornment={{
                readOnly: true,
              }}
              disabled={true}
              size="small"
            />
            <CustomSelectField
              label="Fiscal Period Status"
              propertyName="statusID"
              onBlur={handleBlur}
              onChange={handleChange}
              values={values}
              touched={touched}
              errors={errors}
              options={[
                { label: "Open", value: 2 },
                { label: "Closed", value: 3 },
              ]}
              readOnly={periodData.statusID === 3 ? true : false}
              disabled={periodData.statusID === 3 ? true : false}
              size="small"
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  onCloseDialog();
                }}
              >
                <i className="fas fa-window-close"></i>
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
                disabled={isSubmitting}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </React.Fragment>
  );
}

export default OpenClosePeriodForm;
